import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { AppAccessKey, LmUserClaim, SdIdmCore } from 'core/utils/Constants';
import Header from '../header/Header';
import { ApolloProvider } from '@apollo/client';
import useAppApolloClient from '../../core/hooks/useApolloClient';

const Layout = () => {
  const auth = useAuth();
  const location = useLocation();

  const apolloClient = useAppApolloClient();

  if (
    auth.user?.profile[LmUserClaim] !== undefined &&
    (auth.user?.profile[AppAccessKey] as string[])?.includes(SdIdmCore)
  ) {
    return (
      <ApolloProvider client={apolloClient}>
        <div className="h-screen">
          <Header />
          <main className="h-[calc(100vh-4rem)]">
            <Outlet />
          </main>
        </div>
      </ApolloProvider>
    );
  }

  if (auth.user) {
    return <Navigate to="/unauthorized" state={{ from: location }} />;
  }

  if (auth.isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <Navigate to="/login" state={{ from: location }} />;
};

export default Layout;
